import { Share } from "components";
import { Text, Divider } from '@chakra-ui/react';
import { FC, useMemo } from "react";
import { useLoggedinUser, usePack } from "lib/hooks";
import { useActivePackContext } from "lib/context";
import { isAdmin, isOwner } from "lib/utils";

// TODO: Type declarations
export const AdminLevelShare: FC<any> = ({ shareTokens, team }) => {
  const { activePack } = useActivePackContext();
  const { data: pack } = usePack(activePack?.id);
  const { data: user } = useLoggedinUser();

  const tokens = useMemo(() =>
    shareTokens?.filter(({ permission }) => permission === 'admin'
  ), [ shareTokens ]);

  if (!isOwner(pack, user) && !isAdmin(pack)) {
    return null;
  }

  return (
    <>
      {tokens?.map((token: any, index: number) => (
        <div key={token.id}>
          <Share token={token} title="Admin" team={team} displayToggle={isOwner(pack, user)}>
            <Text size="sm">A team member with this link has the same permission levels you have for this pack. But they won&apos;t be able to delete the pack.</Text>
          </Share>
          {tokens.length > 1 && index !== tokens.length-1 && <Divider mt="20px" mb="20px" />}
        </div>
      ))}
    </>
  )
};
